export default __webpack_public_path__ + "static/media/right_ins.d02b0b27.svg";